module.exports = {
	"rating": "findify-components--cards--product--rating__rating",
	"stars": "findify-components--cards--product--rating__stars",
	"star": "findify-components--cards--product--rating__star",
	"filled": "findify-components--cards--product--rating__filled",
	"count": "findify-components--cards--product--rating__count"
};